// The date format of the `feedback.shownAt` property (client-side)
const shownAtDateFormat = "MM/DD/YYYY";

export default shownAtDateFormat;
